import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import Helper from '@shared/utils/Helper';
import { SessionSecurityService } from '@shared/services';


@Injectable({
  providedIn: 'root'
})
export class SidenavService {

  constructor(private sessionSecurity: SessionSecurityService){

  }

  private sideMenu: MatSidenav;

  public setSideMenu(sidenav: MatSidenav) {
    this.sideMenu = sidenav;
  }

  //Function to check the device and toggle side nav
  public toggle(): void {
    let userDevice = this.sessionSecurity.getObject('Device');

    if(Helper.hasAny(userDevice)){
      if(userDevice == "Mobile" || userDevice == "Tablet") {
        this.sideMenu.toggle();
      }
    }    
  }
}
